import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { fetchEmployeeNotificationsPaginated } from './useEmployeeNotificationsPaginatedQuery'
import { EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY } from '../employeeNotificationQueryKeys'

export function useEmployeeNotificationsUnreadCountQuery(
  options?: Omit<UseQueryOptions<number>, 'queryKey' | 'queryFn' | 'select'>
) {
  return useQuery({
    queryKey: [EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
    queryFn: () =>
      fetchEmployeeNotificationsPaginated({
        pageIndex: 1,
        pageSize: 1,
        isRead: false,
      }),
    select: (data) => data.totalCount,
    ...options,
  })
}

export function useEmployeeNotificationsUnreadCount(
  options?: Omit<UseQueryOptions<number>, 'queryKey' | 'queryFn' | 'select'>
) {
  const query = useEmployeeNotificationsUnreadCountQuery(options)
  const unreadCount = computed(() => query.data.value ?? 0)

  return {
    ...query,
    unreadCount,
  }
}
